import React, { Component } from 'react'
import _, { map } from 'lodash'
import { Dimmer, Loader } from 'semantic-ui-react'

class RealTimeTracker extends Component {
  componentDidMount() {
    const { loaded, fetch } = this.props

    if (!loaded) fetch()
  }

  filterOrder(filter) {
    const { data } = this.props

    const filterData = _.pickBy(data, order => order.status === filter)
    return map(filterData)
  }

  render() {
    const { type, data, icon, loading, label, actualValue, valueStyle, iconStyle } = this.props
    const valueCount = data ? map(data).length : '...'
    const displayValue = actualValue || valueCount

    if (type === 'order') {
      return (
        <div className="ui segment">
          {loading && (
            <Dimmer active inverted>
              <Loader />
            </Dimmer>
          )}
          <div className="ui equal width grid">
            <div className="column middle aligned">
              <i aria-hidden="true" className={`${icon} huge icon`} style={{ color: '#ffd54f' }} />
            </div>
            <div className="column middle center aligned">
              <h3>Orders</h3>
              <h1>{data ? map(data).length : '...'}</h1>
            </div>
            {/* <div className="column middle center aligned">
              <h3>Pending Orders</h3>
              <h1>{data ? this.filterOrder('pending').length : '...'}</h1>
            </div> */}
            <div className="column middle center aligned">
              <h3>Completed</h3>
              <h1>{data ? this.filterOrder('delivered').length : '...'}</h1>
            </div>
            <div className="column middle center aligned">
              <h3>Rejected</h3>
              <h1>{data ? this.filterOrder('rejected').length : '...'}</h1>
            </div>
          </div>
        </div>
      )
    } else if (type === 'express_order') {
      return (
        <div className="ui segment">
          {loading && (
            <Dimmer active inverted>
              <Loader />
            </Dimmer>
          )}
          <div className="ui equal width grid">
            <div className="column middle aligned">
              <i aria-hidden="true" className={`${icon} huge icon`} style={{ color: '#ffd54f' }} />
            </div>
            <div className="column middle center aligned">
              <h3>Orders</h3>
              <h1>{data ? map(data).length : '...'}</h1>
            </div>
            <div className="column middle center aligned">
              <h3>Completed </h3>
              <h1>{data ? this.filterOrder('delivered').length : '...'}</h1>
            </div>
            <div className="column middle center aligned">
              <h3>Rejected </h3>
              <h1>{data ? this.filterOrder('drafted').length : '...'}</h1>
            </div>
          </div>
        </div>
      )
    } else {
      return (
        <div className="ui segment">
          <div className="ui equal width grid">
            <div className="column middle aligned" style={{ ...iconStyle }}>
              <i aria-hidden="true" className={`${icon} huge icon`} style={{ color: '#ffd54f' }} />
            </div>
            <div className="column right aligned" style={{ ...valueStyle }}>
              <h4>{label}</h4>
              <h1>{displayValue}</h1>
            </div>
          </div>
        </div>
      )
    }
  }
}

export default RealTimeTracker



// WEBPACK FOOTER //
// ./src/components/common/tracker.js